export default __webpack_public_path__ + "static/media/DP2 1A-1B.fb53eab9.jpg";